<template>
  <div>
    <el-form :model="ruleForm" ref="ruleForm" label-width="200px">
      <el-form-item
        label="Email Address"
        
        prop="email"
        :rules="[{ required: true, message: '', trigger: 'blur' }]"
      >
        <el-input :disabled="userInfo.roleId == roleClerkId || userInfo.roleId == roleManagerId" v-model="ruleForm.email"></el-input>
      </el-form-item>
      <el-form-item
        label="Password"
        prop="password"
        :rules="[{ required: true, message: '', trigger: 'blur' }]"
      >
        <el-input :disabled="userInfo.roleId == roleClerkId || userInfo.roleId == roleManagerId" v-model="ruleForm.password" show-password></el-input>
      </el-form-item>
      <el-form-item
        label="Status"
        prop="status"
        :rules="[{ required: true, message: '', trigger: 'blur' }]"
      >
        <el-select v-model="ruleForm.status" :disabled="userInfo.roleId == roleClerkId || userInfo.roleId == roleManagerId" placeholder="請选择">
          <el-option
            v-for="item in userStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="Role"
        prop="roleId"
        :rules="[{ required: true, message: '', trigger: 'blur' }]"
      >
        <el-select v-model="ruleForm.roleId" :disabled="userInfo.roleId == roleClerkId || userInfo.roleId == roleManagerId" placeholder="">
          <el-option
            v-for="item in userRoleId"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="Assign Applications"
        v-if="ruleForm.roleId == 4"
        :rules="[{ required: ruleForm.roleId== 4, message: '', trigger: 'blur' }]"
      >
        <el-select v-model="ruleForm.assignApplicationFormType" multiple  placeholder="">
         <el-option
            v-for="(item, index) in formTo"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    ruleForm: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  background-color: #fff;
}
</style>